import { createFileRoute } from "@tanstack/react-router";
import { OrganizationWageSetDetailPage } from "@/features/organization-wage-sets/components/organization-wage-set-detail-page";

export const Route = createFileRoute(
  "/_org/org/bu/$organizationBusinessUnitId/jobs/wage-sets/$organizationWageSetId/",
)({
  component: OrganizationWageSetDetailRoute,
});

function OrganizationWageSetDetailRoute() {
  const { user } = Route.useRouteContext();
  const { organizationWageSetId } = Route.useParams();
  return (
    <OrganizationWageSetDetailPage
      organizationWageSetId={organizationWageSetId}
      user={user}
    />
  );
}
